import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import Button from '@components/Button'
import ProductListing from '@components/ProductListing'
import OptionalExtras from './OptionalExtras'

import { ReactComponent as Tick } from '@assets/svgs/icons/tick.svg'
import './ProductSummary.module.scss'

class ProductSummary extends Component {
  state = {
    extras: [],
    added: 0
  }

  componentDidMount () {
    const { product } = this.props
    const optionalExtras = R.prop('optionalExtras', product)
    const extras = this.flattenOptionalExtras(optionalExtras)
    this.setState({ extras })
  }

  continueBrowsing = () => {
    this.addAddedExtras()
  }

  goToBasket = () => {
    this.addAddedExtras(true)
  }

  addAddedExtras = (redirect = false) => {
    const { extras } = this.state
    const { addOptionalExtras } = this.props
    const addedExtras = R.filter(extra => R.gt(extra.quantity, 0), extras)

    addOptionalExtras(addedExtras, redirect)
  }

  flattenOptionalExtras (optionalExtras) {
    const { product } = this.props
    const startDate = R.prop('startDate', product)
    const endDate = R.prop('endDate', product)

    return R.map((extra) => {
      const item = {}

      item.slug = R.prop('slug', extra)
      item.title = R.prop('title', extra)
      item.productCode = R.path(['template', '0', 'productCode'], extra)
      item.image = R.pathOr(null, ['template', '0', 'image', 'resize', 'src'], extra)
      item.ppe = R.pipe(
        R.pathOr([], ['template', '0', 'ppe']),
        R.map(R.prop('title'))
      )(extra)
      item.quantity = '0'
      item.startDate = startDate
      item.endDate = endDate

      return item
    }, optionalExtras)
  }

  increment = (index) => {
    let { extras, added } = this.state
    const extra = R.prop(index, extras)
    let quantity = Number(R.prop('quantity', extra))

    if (quantity < 25) {
      quantity += 1
      added += 1
    }

    extra.quantity = String(quantity)
    extras[index] = extra

    this.setState({ extras, added })
  }

  decrement = (index) => {
    let { extras, added } = this.state
    const extra = R.prop(index, extras)
    let quantity = Number(R.prop('quantity', extra))

    if (quantity > 0) {
      quantity -= 1
      added -= 1
    }

    extra.quantity = String(quantity)
    extras[index] = extra

    this.setState({ extras, added })
  }

  render () {
    const { extras, added } = this.state
    const { product } = this.props

    return (
      <Fragment>
        <h4 styleName='cornerTitle'>Add to Hire Quote List</h4>

        <div styleName='container'>
          <section styleName='header'>
            <div styleName='phoneInfo'>
              <span styleName='phoneLabel'>Need help? Call us</span>
              <a href='tel:033448921878' styleName='phoneNo'>03344 892 1878</a>
            </div>
            <div styleName='buttons'>
              {added > 0 && (
                <p styleName='added'>
                  <Tick />
                  Adding {added} extra items
                </p>
              )}
              <div styleName='buttonWrapper'>
                <Button type='alt' click={this.continueBrowsing}>Continue Browsing</Button>
              </div>
              <div styleName='buttonWrapper'>
                <Button click={this.goToBasket}>Proceed to Quote List</Button>
              </div>
            </div>
          </section>

          <div styleName='productWrapper'>
            {product && <ProductListing product={product} />}
          </div>

          <OptionalExtras
            extras={extras}
            increment={this.increment}
            decrement={this.decrement}
          />

          <section styleName='footer'>
            <div styleName='buttons'>
              {added > 0 && (
                <p styleName='added'>
                  <Tick />
                  Adding {added} extra items
                </p>
              )}
              <div styleName='buttonWrapper'>
                <Button type='alt' click={this.continueBrowsing}>Continue Browsing</Button>
              </div>
              <div styleName='buttonWrapper'>
                <Button click={this.goToBasket}>Proceed to Quote List</Button>
              </div>
            </div>
          </section>

        </div>
      </Fragment>
    )
  }
}

ProductSummary.propTypes = {
  product: PropTypes.object.isRequired,
  addOptionalExtras: PropTypes.func.isRequired
}

export default ProductSummary



// WEBPACK FOOTER //
// ./src/components/ProductSummary/ProductSummary.js